export default "/icons/git-alt.svg";